import { OVERLAY_KEYS } from '../../../constants';
import { useOverlay } from '../../../hooks/useOverlay';
import Container from '../../containers/container';
import Button from './button';

type Props = {
  id: string;
  name: OVERLAY_KEYS;
};

export default function OverlayButton({ id, name }: Props) {
  const [openOverlay] = useOverlay(name, id);

  return (
    <Container extensions="mobile:block tablet-lg:hidden">
      <Button
        onClick={openOverlay}
        withButtonStyle
        asIcon="dots"
        size="sm"
        color="glass"
      />
    </Container>
  );
}
